import type { FaireThemeEntity } from "../../entity_types/theme";

export const mindful_sips_and_spirits: FaireThemeEntity = {
  token: "mindful-sips-and-spirits",
  type: "theme",
  name: "Mindful Sips & Spirits",
  description: "Clean, refreshing beverages that complement your spiritual and wellness-focused product range. A perfect pairing for customers browsing your crystals and books.",
  teaser: "Your shop specializes in Vedic & Shamanic practices, crystal healing, and therapeutic bodywork. Products like Green Tea and purified Core Water align with the health-conscious lifestyle of your clientele.",
  detail: "The additional_context payload supports this theme because it includes naturally sweetened Arizona Green Tea and hydrating Core Water, which fit the wellness-oriented profile of your store.",
  bgColor: "#F5E6CC",
  tileBgColor: "#6b6337",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_dikpnp7sbh",
    "p_jr5u69qpyu",
    "p_2zbwp6qqnd",
    "p_c3eihau59b",
    "p_vn68tpa9xz",
    "p_q8jecsnm5h",
    "p_8sf7m8t2nj",
    "p_dwucw6bht2",
    "p_zdwjfqc75v",
    "p_285uz3gszw",
    "p_hqf8rvnbv5",
    "p_t23t97pzcd",
    "p_usk589escg",
    "p_3yhcdrsywq",
    "p_96ywvevwpy",
    "p_f43ya29aav",
    "p_hmubyf4f8e",
    "p_jsp9c3t54n",
    "p_ddpcnbh36d",
    "p_2hmv6raml2",
    "p_vju8vk484w",
    "p_thdy9efqx6",
    "p_97pspet94z",
    "p_r4wwg4haak",
    "p_gr4eh8zxdy",
    "p_m24qga7rtw",
    "p_sz45g4fgte",
    "p_zdnfh952dy",
    "p_8v9tm78826",
    "p_7qdxfxqwtt",
    "p_5wayvfmqcv",
    "p_rsd2f26c58",
    "p_vpwb24kxq2",
    "p_vy6kbe49tp",
    "p_k3dyn8wr2j",
    "p_4uchs5d2z4",
    "p_4df3abffbk",
    "p_2k85eg5vnk",
    "p_nstqjgvs38",
    "p_a27bsyqv9x",
    "p_s7m6d3zb8j",
    "p_qd2d3ntp4w",
    "p_nxgeqkuueg",
    "p_hktqhc7ram",
    "p_86zhqscuzx",
    "p_9vxv4ftn42",
    "p_whpjhamvz9",
    "p_bb85pam5s2",
    "p_dxmqwdn83h",
    "p_tz35n4bb3s",
    "p_y8vm9y2utm",
    "p_dymv7mfgpy",
    "p_7ehm9uwt6f",
    "p_s9evtgex34",
    "p_g3syszptaw",
    "p_4sbrh9mp6y",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
